import type { AssetLibraryFilter, AssetLibraryItem, AssetLibraryType } from '@/types/nf'

export const assetLibraryTypes = ['character', 'scene', 'prop', 'voice'] as const satisfies readonly AssetLibraryType[]

export interface AssetLibraryTab {
  type: AssetLibraryFilter
  count: number
}

export interface AssetLibraryState {
  activeType: AssetLibraryFilter
  tabs: AssetLibraryTab[]
  items: AssetLibraryItem[]
}

export function deriveAssetLibraryState(
  items: AssetLibraryItem[],
  selectedType: AssetLibraryFilter,
): AssetLibraryState {
  const counts = new Map<AssetLibraryType, number>()
  for (const item of items) {
    counts.set(item.type, (counts.get(item.type) ?? 0) + 1)
  }
  const tabs: AssetLibraryTab[] = [{ type: 'all', count: items.length }]
  for (const type of assetLibraryTypes) {
    const count = counts.get(type) ?? 0
    if (count > 0) tabs.push({ type, count })
  }
  const activeType = selectedType === 'all' || (counts.get(selectedType) ?? 0) > 0 ? selectedType : 'all'
  return {
    activeType,
    tabs,
    items: activeType === 'all' ? items : items.filter((item) => item.type === activeType),
  }
}
